import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/rectangleplus.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FULL_API_BASE_URL } from "../../../Config/Config";
// import "../QuestionDashboard/questiondashborad.css";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";
import TableComponent from "../DashboardCreateQuestionpaper/TableComponentV4";
const QuestionPaperDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
  }, [dataClient]);

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  //   make a cosnt varible to call userId from local storage
  // const userID = localStorage.getItem("userId");
  const userId = dataClient?.client_schema_name?.[6]?.[0]?.user_id;
  // console.log("userId", userId);
  // console.log("userID", userID);
  // console.log("dataClient", dataClient?.client_schema_name?.[6]?.[0]?.user_id);
  const fetchDashboardData = async () => {
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-assignor-dashboard-details/?user_id=${userId}`,
        // `${FULL_API_BASE_URL}/get-assignee-dashboard-details/?user_id=${userId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          "Failed to fetch dashboard data. Please check the API or authentication details."
        );
      }

      const result = await response.json();

      // Extract table data directly
      const tableData = result?.table_data || [];
      const headers = tableData[0] || [];
      const rows = tableData.slice(1) || [];

      // Format headers by removing t* prefix
      const formattedHeaders = headers.map((header) =>
        header.replace(/^t\*/, "")
      );

      // Format rows with proper date handling and status conversion
      const transformedRows = rows.map((row) =>
        row.map((cell, index) => {
          // Handle dates (Create Date and Due By columns)
          if (
            headers[index] === "t*Cretae Date" ||
            headers[index] === "t*Due By"
          ) {
            if (!cell) return "";
            try {
              const date = new Date(cell);
              return date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              });
            } catch {
              return cell;
            }
          }

          // Handle Overall status
          if (headers[index] === "t*Overall status") {
            return cell === 1 ? "Active" : "Inactive";
          }

          // Handle empty strings
          if (cell === "") {
            return `***`;
          }

          // Return all other cells as is
          return cell;
        })
      );

      setHeaders(formattedHeaders);
      setReportDashboardData(transformedRows);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      // Optionally set an error state here
    }
  };
  //   const fetchDashboardData = async () => {
  //     try {
  //       const response = await fetch(
  //         `${FULL_API_BASE_URL}/get-assignee-dashboard-details/?user_id=${userID}`,
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: `Bearer ${accessToken}`,
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       if (!response.ok) {
  //         throw new Error(
  //           "Failed to fetch dashboard data. Please check the API or authentication details."
  //         );
  //       }

  //       const result = await response.json();
  //       const { data, status, message } = result;

  //       if (status !== 200) {
  //         throw new Error(message || "Failed to fetch dashboard data");
  //       }

  //       // Extract headers and rows from the `table_data`
  //       const rawTableData = data?.table_data || [];
  //       const rawHeaders = rawTableData[0] || [];
  //       const rawRows = rawTableData.slice(1) || [];

  //       // Format headers by removing prefixes
  //       const formattedHeaders = rawHeaders.map((header) =>
  //         header.replace(/^t\*|d\*|n\*/, "")
  //       );

  //       // Format rows: Handle dates and other formatting as needed
  //       const formatDate = (dateString) => {
  //         if (!dateString) return null;
  //         const date = new Date(dateString);
  //         return date.toLocaleDateString("en-US", {
  //           year: "numeric",
  //           month: "short",
  //           day: "2-digit",
  //         });
  //       };

  //       const transformedRows = rawRows.map((row) =>
  //         row.map((cell, index) => {
  //           if (rawHeaders[index]?.startsWith("d*")) {
  //             return formatDate(cell);
  //           }
  //           return cell;
  //         })
  //       );
  //       setHeaders(formattedHeaders);
  //       setReportDashboardData(transformedRows);
  //     } catch (error) {
  //       console.error("Error fetching dashboard data:", error);
  //     }
  //   };
  const handleCancel = () => {
    window.location.reload(); // This will refresh the page
  };
  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "37px",
        marginBottom: "40px",
      }}
    >
      <div className="">
        <div className="create-role-container-ques-dashboards">
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>
            Question Paper Dashboard cxv
          </p>
          <div style={{ display: "flex" }}>
            <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
              onClick={handleCancel} // Add onClick handler
            >
              CANCEL
            </button>
            <button
              style={{
                // width: "900px",
                padding: "12px",
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
              className="create-test-section-btn-v2"
              // onClick={() => {
              //   if (selectedRows.length > 0) {
              //     const queryString = selectedRows.join(","); // Join selected IDs with commas
              //     navigate(
              //       `/create_ques_paper?MNTQuestionNumbers=${queryString}`
              //     ); // Pass IDs in the query string
              //   }
              // }}
              onClick={() => {
                // if (selectedRows.length > 0) {
                // const queryString = selectedRows.join(","); // Join selected IDs with commas
                navigate(`/curate_ques_paper`); // Pass IDs in the query string
                // }
              }}
            >
              + CREATE
            </button>
            {/* <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
                width: "160px",
                backgroundColor: selectedRows.length > 0 ? "" : "#d3d3d3",
                cursor: selectedRows.length > 0 ? "pointer" : "not-allowed",
                color: selectedRows.length > 0 ? "#424342" : "",
              }}
              onClick={() => {
                if (selectedRows.length > 0) {
                  const queryString = selectedRows.join(","); // Join selected IDs with commas
                  navigate(`/question_paper_details?MNTQuestionNumbers=${queryString}`); // Pass IDs in the query string
                }
              }}
            >
              REVIEW SELECTED
            </button> */}
          </div>
        </div>
        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          Select the already created question paper or create a new one.
        </p>
        <div>
          <TableComponent
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Questions..."
            dataClient={dataClient}
            setPagePath={setPagePath}
            renderQuestionText={renderQuestionText}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            bulk={false} // Add this prop - set to true for multi-select, false for single-select
          />
        </div>
      </div>
    </div>
  );
};

export default QuestionPaperDashboard;
